// FE-owned photo-card spec: sku -> { family, theme }.
// One-time generated from parabo-templates/data/parabo/photo-card-*/manifest.json,
// hand-maintained going forward: adding a card to parabo-templates requires
// adding its SKU here, otherwise it will not appear on the card pages.
// theme is used verbatim as the ?theme= query param value (URL stability).

export const CARD_FAMILY_PRODUCTS = {
  holiday: { default: 'photo-card', foil: 'photo-card-foil' },
  greeting: { default: 'photo-greeting-card', foil: 'photo-greeting-card-foil' },
};

const CARDS = {
  'photo-card-1-foil': { family: 'holiday', theme: 'Holiday' },
  'photo-card-10': { family: 'holiday', theme: 'Holiday' },
  'photo-card-100': { family: 'holiday', theme: 'Holiday' },
  'photo-card-101': { family: 'holiday', theme: 'Holiday' },
  'photo-card-102': { family: 'holiday', theme: 'Holiday' },
  'photo-card-103': { family: 'holiday', theme: 'Holiday' },
  'photo-card-104': { family: 'holiday', theme: 'Christmas' },
  'photo-card-105': { family: 'holiday', theme: 'Christmas' },
  'photo-card-106': { family: 'holiday', theme: 'Christmas' },
  'photo-card-107': { family: 'holiday', theme: 'Christmas' },
  'photo-card-108': { family: 'holiday', theme: 'Christmas' },
  'photo-card-109': { family: 'holiday', theme: 'Holiday' },
  'photo-card-11': { family: 'holiday', theme: 'Christmas' },
  'photo-card-110': { family: 'holiday', theme: 'Holiday' },
  'photo-card-111': { family: 'holiday', theme: 'Holiday' },
  'photo-card-112': { family: 'greeting', theme: 'Other' },
  'photo-card-113': { family: 'holiday', theme: 'Upload Your Own' },
  'photo-card-114': { family: 'holiday', theme: 'Upload Your Own' },
  'photo-card-115': { family: 'greeting', theme: 'Birth Announcement' },
  'photo-card-116': { family: 'greeting', theme: 'Other' },
  'photo-card-117': { family: 'greeting', theme: 'Thank You' },
  'photo-card-118': { family: 'greeting', theme: 'Hello' },
  'photo-card-119': { family: 'greeting', theme: 'Save the Date' },
  'photo-card-12': { family: 'holiday', theme: 'Christmas' },
  'photo-card-120': { family: 'greeting', theme: 'Hello' },
  'photo-card-121': { family: 'greeting', theme: 'Other' },
  'photo-card-122': { family: 'greeting', theme: 'Other' },
  'photo-card-123': { family: 'greeting', theme: 'Hello' },
  'photo-card-124': { family: 'greeting', theme: 'Thank You' },
  'photo-card-125': { family: 'greeting', theme: 'Other' },
  'photo-card-126': { family: 'greeting', theme: 'Thank You' },
  'photo-card-127': { family: 'greeting', theme: 'Save the Date' },
  'photo-card-128': { family: 'greeting', theme: 'Other' },
  'photo-card-129': { family: 'greeting', theme: 'Other' },
  'photo-card-13': { family: 'holiday', theme: 'Christmas' },
  'photo-card-130': { family: 'greeting', theme: 'Save the Date' },
  'photo-card-131': { family: 'greeting', theme: 'Save the Date' },
  'photo-card-132': { family: 'greeting', theme: 'Birth Announcement' },
  'photo-card-133-foil': { family: 'greeting', theme: 'Hello' },
  'photo-card-134-foil': { family: 'greeting', theme: 'Save the Date' },
  'photo-card-135-foil': { family: 'greeting', theme: 'Birth Announcement' },
  'photo-card-136': { family: 'greeting', theme: 'Upload Custom' },
  'photo-card-137': { family: 'greeting', theme: 'Upload Custom' },
  'photo-card-138': { family: 'greeting', theme: 'Save the Date' },
  'photo-card-139': { family: 'greeting', theme: 'Save the Date' },
  'photo-card-14': { family: 'holiday', theme: 'Holiday' },
  'photo-card-140-foil': { family: 'greeting', theme: 'Save the Date' },
  'photo-card-141': { family: 'greeting', theme: 'Save the Date' },
  'photo-card-142': { family: 'greeting', theme: 'Birth Announcement' },
  'photo-card-143': { family: 'greeting', theme: 'Thank You' },
  'photo-card-144': { family: 'greeting', theme: 'Thank You' },
  'photo-card-145': { family: 'greeting', theme: 'Thank You' },
  'photo-card-146-foil': { family: 'greeting', theme: 'Thank You' },
  'photo-card-147-foil': { family: 'holiday', theme: 'New Year' },
  'photo-card-148-foil': { family: 'holiday', theme: 'Holiday' },
  'photo-card-149-foil': { family: 'holiday', theme: 'Holiday' },
  'photo-card-15': { family: 'holiday', theme: 'Holiday' },
  'photo-card-150-foil': { family: 'holiday', theme: 'New Year' },
  'photo-card-151-foil': { family: 'holiday', theme: 'Holiday' },
  'photo-card-152': { family: 'holiday', theme: 'Holiday' },
  'photo-card-153': { family: 'holiday', theme: 'Holiday' },
  'photo-card-154': { family: 'holiday', theme: 'Holiday' },
  'photo-card-155': { family: 'holiday', theme: 'Holiday' },
  'photo-card-156': { family: 'holiday', theme: 'Holiday' },
  'photo-card-157': { family: 'holiday', theme: 'Holiday' },
  'photo-card-158': { family: 'holiday', theme: 'Holiday' },
  'photo-card-159': { family: 'holiday', theme: 'Holiday' },
  'photo-card-16': { family: 'holiday', theme: 'Holiday' },
  'photo-card-160': { family: 'holiday', theme: 'Holiday' },
  'photo-card-161': { family: 'holiday', theme: 'Holiday' },
  'photo-card-162': { family: 'holiday', theme: 'Holiday' },
  'photo-card-163': { family: 'holiday', theme: 'Holiday' },
  'photo-card-164': { family: 'holiday', theme: 'Holiday' },
  'photo-card-165': { family: 'holiday', theme: 'Holiday' },
  'photo-card-166': { family: 'holiday', theme: 'Holiday' },
  'photo-card-167': { family: 'holiday', theme: 'Diwali' },
  'photo-card-17': { family: 'holiday', theme: 'Holiday' },
  'photo-card-18': { family: 'holiday', theme: 'New Year' },
  'photo-card-19': { family: 'holiday', theme: 'New Year' },
  'photo-card-2-foil': { family: 'holiday', theme: 'Holiday' },
  'photo-card-20': { family: 'holiday', theme: 'Christmas' },
  'photo-card-21-foil': { family: 'holiday', theme: 'Holiday' },
  'photo-card-22-foil': { family: 'holiday', theme: 'Holiday' },
  'photo-card-23-foil': { family: 'holiday', theme: 'Christmas' },
  'photo-card-24': { family: 'holiday', theme: 'Holiday' },
  'photo-card-25': { family: 'holiday', theme: 'New Year' },
  'photo-card-26-foil': { family: 'holiday', theme: 'Holiday' },
  'photo-card-27-foil': { family: 'holiday', theme: 'Holiday' },
  'photo-card-28-foil': { family: 'holiday', theme: 'Holiday' },
  'photo-card-29-foil': { family: 'holiday', theme: 'New Year' },
  'photo-card-3': { family: 'holiday', theme: 'Holiday' },
  'photo-card-30': { family: 'holiday', theme: 'Holiday' },
  'photo-card-31': { family: 'holiday', theme: 'Holiday' },
  'photo-card-32': { family: 'holiday', theme: 'Holiday' },
  'photo-card-33': { family: 'holiday', theme: 'Holiday' },
  'photo-card-34': { family: 'holiday', theme: 'Holiday' },
  'photo-card-35': { family: 'holiday', theme: 'Christmas' },
  'photo-card-36': { family: 'holiday', theme: 'Christmas' },
  'photo-card-37': { family: 'holiday', theme: 'Christmas' },
  'photo-card-38': { family: 'holiday', theme: 'Christmas' },
  'photo-card-39': { family: 'holiday', theme: 'Holiday' },
  'photo-card-4-foil': { family: 'holiday', theme: 'Holiday' },
  'photo-card-40': { family: 'holiday', theme: 'Holiday' },
  'photo-card-41': { family: 'holiday', theme: 'Holiday' },
  'photo-card-42-foil': { family: 'holiday', theme: 'Holiday' },
  'photo-card-43-foil': { family: 'holiday', theme: 'New Year' },
  'photo-card-44': { family: 'holiday', theme: 'New Year' },
  'photo-card-45': { family: 'holiday', theme: 'Christmas' },
  'photo-card-46': { family: 'holiday', theme: 'Holiday' },
  'photo-card-47': { family: 'holiday', theme: 'Christmas' },
  'photo-card-48': { family: 'holiday', theme: 'Holiday' },
  'photo-card-49': { family: 'holiday', theme: 'New Year' },
  'photo-card-5-foil': { family: 'holiday', theme: 'Holiday' },
  'photo-card-50': { family: 'holiday', theme: 'Holiday' },
  'photo-card-51': { family: 'holiday', theme: 'Holiday' },
  'photo-card-52-foil': { family: 'holiday', theme: 'Holiday' },
  'photo-card-53': { family: 'holiday', theme: 'Holiday' },
  'photo-card-54': { family: 'holiday', theme: 'Holiday' },
  'photo-card-55': { family: 'holiday', theme: 'Holiday' },
  'photo-card-56': { family: 'holiday', theme: 'Hanukkah' },
  'photo-card-57': { family: 'holiday', theme: 'Holiday' },
  'photo-card-58': { family: 'holiday', theme: 'Holiday' },
  'photo-card-59': { family: 'holiday', theme: 'Holiday' },
  'photo-card-6-foil': { family: 'holiday', theme: 'New Year' },
  'photo-card-60': { family: 'holiday', theme: 'Christmas' },
  'photo-card-61': { family: 'holiday', theme: 'New Year' },
  'photo-card-62': { family: 'holiday', theme: 'New Year' },
  'photo-card-63-foil': { family: 'holiday', theme: 'Hanukkah' },
  'photo-card-64-foil': { family: 'holiday', theme: 'Hanukkah' },
  'photo-card-65-foil': { family: 'holiday', theme: 'Holiday' },
  'photo-card-66-foil': { family: 'holiday', theme: 'Christmas' },
  'photo-card-67': { family: 'holiday', theme: 'Christmas' },
  'photo-card-68': { family: 'holiday', theme: 'Christmas' },
  'photo-card-69-foil': { family: 'holiday', theme: 'Holiday' },
  'photo-card-7-foil': { family: 'holiday', theme: 'Christmas' },
  'photo-card-70-foil': { family: 'holiday', theme: 'Holiday' },
  'photo-card-71-foil': { family: 'holiday', theme: 'Hanukkah' },
  'photo-card-72': { family: 'holiday', theme: 'Holiday' },
  'photo-card-73': { family: 'holiday', theme: 'Holiday' },
  'photo-card-74': { family: 'holiday', theme: 'Christmas' },
  'photo-card-75': { family: 'holiday', theme: 'Holiday' },
  'photo-card-76': { family: 'holiday', theme: 'Holiday' },
  'photo-card-77': { family: 'holiday', theme: 'Holiday' },
  'photo-card-78-foil': { family: 'holiday', theme: 'Holiday' },
  'photo-card-79-foil': { family: 'holiday', theme: 'Hanukkah' },
  'photo-card-8-foil': { family: 'holiday', theme: 'Holiday' },
  'photo-card-80-foil': { family: 'holiday', theme: 'Christmas' },
  'photo-card-81': { family: 'holiday', theme: 'Holiday' },
  'photo-card-82': { family: 'holiday', theme: 'Christmas' },
  'photo-card-83': { family: 'holiday', theme: 'Christmas' },
  'photo-card-84-foil': { family: 'holiday', theme: 'Hanukkah' },
  'photo-card-85-foil': { family: 'holiday', theme: 'New Year' },
  'photo-card-86-foil': { family: 'holiday', theme: 'Holiday' },
  'photo-card-87-foil': { family: 'holiday', theme: 'Holiday' },
  'photo-card-88-foil': { family: 'holiday', theme: 'Holiday' },
  'photo-card-89-foil': { family: 'holiday', theme: 'Holiday' },
  'photo-card-9': { family: 'holiday', theme: 'Holiday' },
  'photo-card-90-foil': { family: 'holiday', theme: 'New Year' },
  'photo-card-91-foil': { family: 'holiday', theme: 'Christmas' },
  'photo-card-92-foil': { family: 'holiday', theme: 'Christmas' },
  'photo-card-93-foil': { family: 'holiday', theme: 'Christmas' },
  'photo-card-94-foil': { family: 'holiday', theme: 'Christmas' },
  'photo-card-95-foil': { family: 'holiday', theme: 'Christmas' },
  'photo-card-96-foil': { family: 'holiday', theme: 'Holiday' },
  'photo-card-97': { family: 'holiday', theme: 'Hanukkah' },
  'photo-card-98': { family: 'holiday', theme: 'Holiday' },
  'photo-card-99': { family: 'holiday', theme: 'Hanukkah' },
};

export default CARDS;
